import { render } from "./BranchCards.vue?vue&type=template&id=349606fe"
import script from "./BranchCards.vue?vue&type=script&lang=js"
export * from "./BranchCards.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__